import React from "react";
import {Radio} from "antd";
import classNames from "classnames";
import TableSvg from "../../../../asset/icon/Table.svg";
import ListSvg from "../../../../asset/icon/List.svg";

export const ListType = {
    card: "card", // 宫格模式
    table: "table", // 列表模式/表格
};

// 宫格模式、列表模式选择
const ListTypeRadioGroup = ({
    value,
    onChange,
    style,
    className,
}) => {
    return (
        <Radio.Group
            buttonStyle="solid"
            value={value}
            onChange={onChange}
            className={classNames(className, "renyuan-radio-group")}
            style={{...style}}
        >
            <Radio.Button value={ListType.card}>
                <div style={{height: "100%", display: "flex", alignItems: "center"}}>
                    <TableSvg style={{fontSize: 16}} />
                </div>
            </Radio.Button>
            <Radio.Button value={ListType.table}>
                <div className="flex flex-alignItemsCenter" style={{height: "100%", display: "flex", alignItems: "center"}}>
                    <ListSvg style={{fontSize: 16}} />
                </div>
            </Radio.Button>
        </Radio.Group>
    );
};

export default ListTypeRadioGroup;
